import styled from 'styled-components';
import { animated } from 'react-spring';
import { COLORS } from '../../styles/variables';
import { AlphaTheme } from '../../../design-system/ThemeProvider/alphaTheme';

export const CTAsWrapper = styled(animated.div)`
  left: 12px;
  right: 12px;
  position: sticky;
  bottom: 0;
  background-color: ${({ theme }: { theme: Partial<AlphaTheme> }) => theme.sidebarDesktop ?? COLORS.white};
  padding: 16px 12px 24px 12px;
`;

export const GroupOfCTAs = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  gap: 8px;
`;

export const ShowResultsCTA = styled.button<{ isZeroResults: boolean }>`
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: ${({ isZeroResults }) => (isZeroResults ? COLORS.grey30 : COLORS.black)};
  color: ${COLORS.white};
  font-family: Audi Type;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.003px;
  cursor: ${({ isZeroResults }) => !isZeroResults && 'pointer'};
`;

export const ResetFilters = styled.button<{ isLoading?: boolean }>`
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: ${COLORS.white};
  color: ${({ isLoading }) => (isLoading ? COLORS.grey30 : COLORS.black)};
  font-family: Audi Type;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.003px;
  cursor: pointer;
  border: ${({ isLoading }) =>
    isLoading ? `1px solid ${COLORS.grey30}` : `1px solid ${COLORS.black}`};
`;
